module.exports = __webpack_public_path__ + "static/media/atu.11a75018.gif";